import React from 'react';
import { MessageCircleHeartIcon } from 'lucide-react';
import { RichText } from './RichText';
const links = [{
  href: '#tomos',
  label: 'Tomos'
}, {
  href: '#bonos',
  label: 'Bonos'
}, {
  href: '#oferta',
  label: 'Oferta'
}, {
  href: '#preguntas',
  label: 'Preguntas'
}];
export function SiteHeader() {
  return <header className="sticky top-0 z-50 border-b border-line/70 bg-cream/90 backdrop-blur" data-id="element-214" data-mp="1ndcyc739wj97">
      
    </header>;
}